import styled from "styled-components";
import { BaseGridContainer } from "../../utils/styles";
export const ProductsWrap = styled(BaseGridContainer) `
	height: auto;
	margin: 12px auto;
`;
